var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPaypal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    preserveAspectRatio: "xMidYMid",
    width: 1024,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m664.41,38.72c-23.71,-27 -66.52,-38.58 -121.33,-38.58l-159.03,0a22.77,22.77 0 0 0 -22.48,19.2l-66.22,419.97c-1.33,8.28 5.08,15.78 13.48,15.78l98.19,0l24.66,-156.4l-0.77,4.9c1.75,-11.07 11.21,-19.22 22.4,-19.22l46.66,0c91.66,0 163.42,-37.22 184.39,-144.92c0.61,-3.18 1.16,-6.29 1.62,-9.32c-2.64,-1.39 -2.64,-1.39 0,0c6.26,-39.81 -0.03,-66.9 -21.56,-91.42",
    fill: "#27346A",
    id: "svg_1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m469.24,115.8a19.96,19.96 0 0 1 8.59,-1.94l124.68,0c14.76,0 28.53,0.97 41.12,2.99a172.77,172.77 0 0 1 10.51,2.01a152.93,152.93 0 0 1 14.61,3.98c6.17,2.07 11.94,4.47 17.24,7.3c6.24,-39.81 -0.05,-66.9 -21.58,-91.42c-23.71,-27 -66.52,-38.58 -121.33,-38.58l-159.03,0c-11.21,0 -20.73,8.15 -22.48,19.2l-66.22,419.96c-1.33,8.3 5.08,15.78 13.47,15.78l98.2,0l51.15,-324.41a19.93,19.93 0 0 1 11.07,-14.86z",
    fill: "#27346A",
    id: "svg_2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m684.35,139.46c-20.97,107.68 -92.73,144.92 -184.39,144.92l-46.68,0c-11.19,0 -20.64,8.15 -22.38,19.22l-30.68,194.45c-1.16,7.24 4.46,13.83 11.78,13.83l82.76,0a19.91,19.91 0 0 0 19.66,-16.8l0.82,-4.23l15.59,-98.85l1,-5.46a19.91,19.91 0 0 1 19.66,-16.8l12.4,0c80.18,0 142.94,-32.58 161.29,-126.77c7.65,-39.37 3.69,-72.24 -16.56,-95.33c-6.14,-6.99 -13.77,-12.77 -22.67,-17.48c-0.48,3.04 -1,6.14 -1.62,9.32z",
    fill: "#2790C3",
    id: "svg_3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m664.03,121.4a152.93,152.93 0 0 0 -9.9,-2.53a186.89,186.89 0 0 0 -10.49,-2.01c-12.6,-2.02 -26.36,-2.99 -41.14,-2.99l-124.66,0a19.67,19.67 0 0 0 -8.59,1.96a19.86,19.86 0 0 0 -11.09,14.86l-26.49,168.01l-0.77,4.9c1.75,-11.07 11.21,-19.22 22.4,-19.22l46.68,0c91.66,0 163.42,-37.22 184.37,-144.92c0.63,-3.18 1.16,-6.27 1.63,-9.32c-5.31,-2.81 -11.05,-5.22 -17.24,-7.28a141.58,141.58 0 0 0 -4.71,-1.46",
    fill: "#1F264F",
    id: "svg_4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPaypal);
export default __webpack_public_path__ + "static/media/ic_paypal.2617db06b9a1ed4945c6e9d0f236427e.svg";
export { ForwardRef as ReactComponent };